import { useMemo } from 'react';
import useHistory from '../../hooks/useHistory';

const useSearchParams = () => {
  const history = useHistory();

  return useMemo(() => {
    const {
      isTransfer,
      applicantId,
      applicationId,
      prospectId,
      residentId,
      fromUnit,
      isCurrentUnitConventional,
      fromBuilding,
      isOverride,
      isCurrentUnitLIHTC,
    } = Object.fromEntries(new URLSearchParams(history.location.search));

    return {
      isTransfer: isTransfer === 'true',
      applicantId,
      applicationId,
      prospectId,
      residentId,
      fromUnit,
      isCurrentUnitConventional: isCurrentUnitConventional === 'true',
      fromBuilding,
      isOverride,
      isCurrentUnitLIHTC: isCurrentUnitLIHTC === 'true',
    };
  }, [history.location.search]);
};

export default useSearchParams;
